import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import App from "./App";
import store from "./store/store";
import "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#B29B84",
        colorBorder: "#E4D7CD",
        colorPrimaryHover: "#E4D7CD",
      },
      components: {
        Segmented: {
          itemSelectedColor: "#fff",
          itemColor: "#594E47",
          itemSelectedBg: "#C6A691",
          trackBg: "rgba(178, 155, 132, 0.3)",
        },
        Input: {
          borderRadius: 8,
        },
        Form: {
          itemMarginBottom: 0,
        },
      },
    }}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>
);
